import { pushCalendarPriceAccuracy } from "@/utils/avoGtm.utils";
import { useEffect, useRef } from "react";
import useStateOfFareCalendar from "./useStateOfFareCalendar";
import { useStore } from "@/contexts/StoreContext";
import { useQuery } from "./useQuery";

export const usePushFareCalendarAccuracy = () => {
  const store = useStore();
  const searchRequest = useQuery();
  const {
    isCompleted,
    isFareCalendarFetched,
    resultsCheapestItinerary,
    pricingMap,
    selectedKey,
    pricingFilters,
  } = useStateOfFareCalendar(store, searchRequest?.isRoundTrip);
  const shouldComparePricing = isCompleted && isFareCalendarFetched;
  const pricingItem = pricingMap[selectedKey];
  const shouldPushEvent = useRef(true);
  const airlineFilters = pricingFilters?.airline?.join(",");
  const isDirect = pricingFilters?.stops?.[0] === 0;
  const resultsCheapestPrice = searchRequest?.isRoundTrip
    ? resultsCheapestItinerary?.cheapestRoundtripTotal
    : resultsCheapestItinerary?.totalPrice;
  const searchAirline = resultsCheapestItinerary?.uniqueCarriersArr.join(",");
  const calendarAirline = pricingItem?.airline;

  useEffect(() => {
    if (shouldComparePricing && shouldPushEvent.current) {
      shouldPushEvent.current = false;
      pushCalendarPriceAccuracy({
        searchPrice: resultsCheapestPrice,
        calendarPrice: pricingItem?.price,
        calendarAirline,
        searchAirline,
        isDirect,
        airlineFilters,
        searchRequest,
        source: pricingItem?.source,
        dateClicked: false,
      });
    }
  }, [resultsCheapestItinerary, shouldComparePricing]);

  useEffect(() => {
    if (!isCompleted) {
      shouldPushEvent.current = true;
    }
  }, [isCompleted]);

  useEffect(() => {
    shouldPushEvent.current = true;
  }, [airlineFilters]);
};
